import { render, staticRenderFns } from "./WhatsAppDisplayNameChange.modal.vue?vue&type=template&id=bccd9d64&scoped=true&"
import script from "./WhatsAppDisplayNameChange.modal.vue?vue&type=script&lang=js&"
export * from "./WhatsAppDisplayNameChange.modal.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppDisplayNameChange.modal.vue?vue&type=style&index=0&id=bccd9d64&prod&lang=scss&scoped=true&"
import style1 from "./WhatsAppDisplayNameChange.modal.vue?vue&type=style&index=1&id=bccd9d64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccd9d64",
  null
  
)

export default component.exports